import { createSample, deleteSample, updateSample } from '../../../actions/samples';

const useControls = (sampleMapId, samples, setSamples) => {
  const canAddControl = () => {
    return samples.length < 96;
  };

  const getControls = () => {
    return samples.filter((sample) => sample.type === 'control');
  };

  // TODO API call
  const createControl = async () => {
    const filledWells = new Set(samples.map((sample) => sample.well));
    for (let i = 0; i < 96; i++) {
      if (!filledWells.has(i)) {
        const newControl = await (await createSample({
          type: 'control',
          name: '',
          controlPrimerName: '',
          well: i,
          sampleMap: sampleMapId,
          concentration: 0,
          readLength: 0,
          volume: 10,
        })).json();
        setSamples(samples => [...samples, newControl]);
        break;
      }
    }
  };

  const updateName = async (id, name) => {
    setSamples(
      samples => samples.map((sample) => {
        if (sample._id === id) {
          updateSample(sample._id, {
            name
          })
          return {
            ...sample,
            name,
          };
        } else {
          return sample;
        }
      })
    );
  };

  const updateControlPrimerName = async (id, primerName) => {
    setSamples(
      samples => samples.map((sample) => {
        if (sample._id === id) {
          updateSample(sample._id, {
            controlPrimerName: primerName
          });
          return {
            ...sample,
            controlPrimerName: primerName,
          };
        } else {
          return sample;
        }
      })
    );
  };

  const deleteControl = async (id) => {
    await deleteSample(id);
    setSamples(samples => samples.filter((sample) => sample._id !== id));
  };

  return {
    canAddControl,
    getControls,
    createControl,
    updateName,
    updateControlPrimerName,
    deleteControl,
  };
};

export default useControls;
